import PropTypes from "prop-types";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

export default function FormInputtext(props) {
  const {
    className = "",
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      elValue,
      elChange,
      maxlength,
      placeholder = "",
      disabled = false,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.target.value;

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    let value = isControl ? field.value : elValue;

    return (
      <div className={classNames("flex align-items-center", className)}>
        <InputText
          id={name}
          className={classNames(
            { "p-invalid": isControl && fieldState.invalid },
            "w-full"
          )}
          name={name}
          value={value ?? ""}
          onChange={(e) => onChange(e, field)}
          maxLength={maxlength}
          placeholder={placeholder}
          disabled={!isEdit || disabled}
        />
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormInputtext.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.any,
    maxlength: PropTypes.number,
    name: PropTypes.string,
    placeholder: PropTypes.string,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
